/**
 * Transient marker that the active demo company was just changed by an EXPLICIT
 * user pick (the homepage company picker) — as opposed to being restored from
 * storage on a page refresh.
 *
 * The persona switcher uses it to resolve a company/persona mismatch in the
 * right direction:
 *   - explicit company pick  → re-point the persona to the new company's cast
 *     (you chose the company; the people should follow).
 *   - refresh / restore      → align the company context to the restored persona
 *     (you were a given person; a stale saved company shouldn't bump you off them).
 *
 * It's a module-scoped variable on purpose: it survives in-session route changes
 * (homepage → timesheet, no reload) but resets on a full page load (refresh) —
 * exactly the signal we need to tell a deliberate switch from a refresh.
 */
let pickedCompanyId: string | null = null

/** Call when the user explicitly picks a demo company (homepage picker). */
export function markCompanyPicked(id: string | null): void {
  pickedCompanyId = id
}

/** Read-and-clear the marker. Returns the picked company id, or null if the
 *  current company arrival was a refresh/restore rather than an explicit pick. */
export function consumeCompanyPick(): string | null {
  const v = pickedCompanyId
  pickedCompanyId = null
  return v
}
